<template>
    <div id="casede">
        <tabtop></tabtop>
        <div class="casede1">
            <img :src="url+banner.images" alt=""  @click="jumpbannerpage(banner.url)">
        </div>
        <div class="casede2">
            <p class="title">{{data.title}}</p>
            <p class="articleMsg">
                <span>{{data.author}}</span>
                <span>{{data.casetime}}</span>
                <span>阅读：{{data.volume}}</span>
            </p>
            <div class="content" v-html="data.content"></div>
        </div>
        <webbottom></webbottom>
    </div>
</template>

<script>
var that
import { rotationmap,casedatade } from '@/api/api'
import tabtop from '@/components/tab/tab.vue'
import webbottom from '@/components/bottom/bottom.vue'
export default {
    name:"about",
    components: {
        tabtop,
        webbottom
    },
    data(){
        return {
            data:{},
            url : window.url,
            banner: {}, 
            caseid:"1"
        }
    },
    mounted(){
        that =this
        if(this.$route.params.id){
            that.caseid = this.$route.params.id
        }
        rotationmap({'type':7}).then((response) => {
            that.banner = response.data.data[0]
        })
        casedatade({'id':that.caseid}).then((response) => {
            for(let i=0;i<response.data.data.length;i++){
                if(response.data.data[i].casetime==null){
                    response.data.data[i].casetime = that.filterTime(response.data.data[i].createtime)
                }
            }
            that.data = response.data.data[0]
        })
    },
    methods:{
        filterTime(time) {
            const date = new Date(time*1000)
            const Y = date.getFullYear()
            const M = date.getMonth() + 1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1 
            const D = date.getDate()
            return `${Y}-${M}-${D}`
        },
        jumpbannerpage(e){
            if(e != this.$route.path) {
                this.$router.push(e)
            }
        }

    }
}
</script>

<style lang="less">
@media (min-width:750px) {
    #casede{
        background: #F8F8F8;
        .casede1{
            img{
                width: 100%;
                display: block;
            }
        }
        .casede2{
            width: 1300px;
            margin:20px auto;
            padding: 40px;
            background: #FFFFFF;
            box-shadow: 0px 3px 12px 1px rgba(66,69,70,0.1);
            border-radius: 12px 12px 12px 12px;
            .title{
                text-align: center;
                font-size: 24px;
                margin-bottom: 30px;
            }
            .content{
                word-break: break-all;
            }
           .articleMsg{
                margin-bottom: 12px;
                span{
                    margin-right: 16px;
                    font-size: 16px;
                    font-weight: 400;
                    color: #AAAAAA;
                }
                span:nth-child(1){
                    color: #3D65FC;
                }
            }
        }

    }
}
@media screen and (max-width:750px) {
    #casede{
        background: #F8F8F8;
        .casede1{
            img{
                width: 100%;
                display: block;
            }
        }
        .casede2{
            width: 90%;
            margin:20px auto;
            padding: 10px;
            background: #FFFFFF;
            box-shadow: 0px 3px 12px 1px rgba(66,69,70,0.1);
            border-radius: 12px 12px 12px 12px;
            .title{
                text-align: center;
                font-size: 24px;
                margin-bottom: 30px;
            }
            .content{
                word-break: break-all;
            }
            .articleMsg{
                margin-bottom: 0.75rem;
                span{
                    margin-right: 1rem;
                    font-size: 1rem;
                    font-weight: 400;
                    color: #AAAAAA;
                }
                span:nth-child(1){
                    color: #3D65FC;
                }
            }
        }
    }
}
</style>